(function () {
  'use strict';

  var state = {
    root: null,
    originalParent: null,
    originalNextSibling: null,
    bundleRoot: null,
    observedBundle: null,
    observer: null,
    dealQuantities: {},
    dealPrices: {},
    currentDealId: null,
    requiredQuantity: 1,
    syncVersion: 0,
    initializeStarted: false,
    refreshTimer: null,
    nativeSelectionReady: false,
    syncing: false,
    syncError: false,
    pendingUpgrade: null,
    pendingUpgradeTimer: null,
    mainButtonObserver: null,
    observedButtonScope: null,
    failedOpen: false,
    entryInitialized: false,
    entryFlavor: '',
    preferredCounts: null,
    extraTins: 0,
    selectionNotice: '',
    presentationRevision: 0
  };

  var BASE_TIN_PRICE = 15.99;
  var PACK_QUANTITIES = [1, 3, 5];

  function parseAndPatchDealSettings() {
    var found = false;
    var tierTitles = {
      1: '1 Tin',
      3: '3 Tins',
      5: '5 Tins'
    };

    document.querySelectorAll('script.kaching-bundles-deal-block-settings').forEach(function (script) {
      try {
        var settings = JSON.parse(script.textContent || '{}');

        // Keep three starter packs on the product page. Larger quantities use the cart.
        settings.dealBars = (settings.dealBars || []).filter(function (deal) {
          return PACK_QUANTITIES.indexOf(Number(deal && deal.quantity)) !== -1;
        });

        settings.differentVariantsEnabled = true;
        settings.showVariantsForSingleQuantity = true;
        settings.disableVariantOptionSync = true;
        settings.subscriptionsEnabled = true;
        if (settings.subscriptions) {
          settings.subscriptions.subscribeTitle = 'Save more with automatic refills';
          settings.subscriptions.subscribeSubtitle = 'Zero commitment, cancel anytime.';
        }
        settings.updateNativePrice = true;
        settings.updateNativePriceType = 'total';
        settings.badgesEnabled = false;
        settings.badges = [];

        (settings.dealBars || []).forEach(function (deal) {
          if (deal && deal.id) {
            var dealId = String(deal.id);
            var quantity = Number(deal.quantity) || 1;
            var tierTitle = tierTitles[quantity];

            state.dealQuantities[dealId] = quantity;

            if (tierTitle) {
              deal.title = tierTitle;
              deal.label = '';
              deal.badgeText = '';

              if (deal.discountType === 'specific') {
                var configuredTotal = Number(deal.discountValue);
                if (Number.isFinite(configuredTotal) && configuredTotal > 0) {
                  var configuredPerTin = configuredTotal / quantity;
                  deal.subtitle = '$' + configuredPerTin.toFixed(2) + ' avg. per tin' +
                    (quantity >= 10 && configuredTotal >= 70 ? ' · Free standard U.S. shipping' : '');
                  state.dealPrices[dealId] = configuredTotal;
                }
              }
            }
          }
        });

        var threeTinDeal = (settings.dealBars || []).find(function (deal) {
          return Number(deal && deal.quantity) === 3;
        });
        if (threeTinDeal && threeTinDeal.id) {
          settings.preselectedDealBarId = threeTinDeal.id;
        }

        script.textContent = JSON.stringify(settings);
        found = true;
      } catch (error) {
        // Leave unrelated or malformed app configuration untouched.
      }
    });

    return found;
  }

  function startKaching() {
    if (state.initializeStarted) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      var settingsReady = parseAndPatchDealSettings();
      if (settingsReady && typeof window.__kachingBundlesInitializeInternal === 'function') {

        try {
          var result = window.__kachingBundlesInitializeInternal();
          state.initializeStarted = true;
          window.clearInterval(timer);

          if (result && typeof result.catch === 'function') {
            result.catch(function () {
              state.initializeStarted = false;
              failOpen();
            });
          }
        } catch (error) {
          state.initializeStarted = false;
          if (attempts >= 300) {
            window.clearInterval(timer);
            failOpen();
          }
        }
      } else if (attempts >= 300) {
        window.clearInterval(timer);
        failOpen();
      }
    }, 50);
  }

  function getDealId(bar) {
    var radio = bar && bar.querySelector('input[type="radio"]');
    return radio ? String(radio.value || '') : '';
  }

  // The app owns both the selected quantity and its price. Read its control;
  // never infer a discount or change the app's native quantity here.
  function getDealQuantity(bar) {
    var configured = state.dealQuantities[getDealId(bar)] || 0;
    var input = bar && bar.querySelector('.kaching-bundles__quantity-selector__input');
    if (!input) return configured;
    var value = Number(input.value);
    var minimum = Math.max(configured, Number(input.getAttribute('min')) || configured);
    var maximum = input.getAttribute('max');
    if (!Number.isSafeInteger(value) || value < minimum ||
      maximum !== null && maximum !== '' && value > Number(maximum)) return 0;
    return value;
  }

  function getSelectedBar() {
    if (!state.bundleRoot) return null;

    return state.bundleRoot.querySelector('.kaching-bundles__bar--selected') ||
      Array.prototype.find.call(
        state.bundleRoot.querySelectorAll('.kaching-bundles__bar'),
        function (bar) {
          var radio = bar.querySelector('input[type="radio"]');
          return radio && radio.checked;
        }
      ) || null;
  }

  function getDealBarByQuantity(quantity) {
    if (!state.bundleRoot) return null;

    return Array.prototype.find.call(
      state.bundleRoot.querySelectorAll('.kaching-bundles__bar'),
      function (bar) {
        return getDealQuantity(bar) === quantity;
      }
    ) || null;
  }

  function getCards() {
    return state.root ? Array.prototype.slice.call(state.root.querySelectorAll('[data-hfs-card]')) : [];
  }

  function getQuantity(card) {
    var input = card.querySelector('[data-hfs-qty]');
    return input ? (parseInt(input.value, 10) || 0) : 0;
  }

  function getCardMaximum(card) {
    var input = card && card.querySelector('[data-hfs-qty]');
    if (!input) return 0;
    var configured = Number(input.getAttribute('data-max'));
    return input.hasAttribute('data-max') && Number.isSafeInteger(configured) && configured >= 0
      ? configured : Number.MAX_SAFE_INTEGER;
  }

  function getTotal() {
    return getCards().reduce(function (sum, card) {
      return sum + getQuantity(card);
    }, 0);
  }

  function hasValidRequiredQuantity() {
    return Number.isSafeInteger(state.requiredQuantity) && state.requiredQuantity > 0;
  }

  function formatMoney(amount) {
    return '$' + Number(amount || 0).toFixed(2);
  }

  function resetCounters() {
    getCards().forEach(function (card) {
      var input = card.querySelector('[data-hfs-qty]');
      if (input) input.value = '0';
      card.classList.remove('is-active');

      var minus = card.querySelector('[data-hfs-step="-1"]');
      var plus = card.querySelector('[data-hfs-step="1"]');
      if (minus) minus.disabled = true;
      if (plus) plus.disabled = card.classList.contains('is-soldout');
    });
  }

  function snapshotCounters() {
    var snapshot = {};

    getCards().forEach(function (card) {
      var variantId = String(card.getAttribute('data-id') || '');
      if (variantId) snapshot[variantId] = getQuantity(card);
    });

    return snapshot;
  }

  function getFlavor(card) {
    var name = card.querySelector('.hfs-name');
    return card.getAttribute('data-flavor') || (name ? name.textContent.trim() : '');
  }

  function getSelectedMix() {
    return getCards().filter(function (card) { return getQuantity(card) > 0; }).map(function (card) {
      return getQuantity(card) + ' ' + getFlavor(card);
    }).join(' + ');
  }

  function fitCounts(snapshot, limit) {
    var target = Math.max(0, Number(limit) || 0);
    var entries = getCards().map(function (card, index) {
      var id = String(card.getAttribute('data-id') || '');
      var max = getCardMaximum(card);
      var count = card.classList.contains('is-soldout') ? 0 :
        Math.min(max, Math.max(0, parseInt(snapshot && snapshot[id], 10) || 0));
      return { id: id, count: count, index: index, remainder: 0 };
    });
    var total = entries.reduce(function (sum, item) { return sum + item.count; }, 0);
    if (total > target) {
      entries.forEach(function (item) {
        var share = item.count * target / total;
        item.count = Math.floor(share);
        item.remainder = share - item.count;
      });
      var unassigned = target - entries.reduce(function (sum, item) { return sum + item.count; }, 0);
      entries.slice().sort(function (a, b) {
        return b.remainder - a.remainder || a.index - b.index;
      }).forEach(function (item) {
        if (unassigned > 0 && item.remainder > 0) { item.count += 1; unassigned -= 1; }
      });
    }
    return entries.reduce(function (result, item) { result[item.id] = item.count; return result; }, {});
  }

  function restoreCounters(snapshot, limit) {
    var fitted = fitCounts(snapshot, limit);
    getCards().forEach(function (card) {
      var input = card.querySelector('[data-hfs-qty]');
      var quantity = fitted[String(card.getAttribute('data-id') || '')] || 0;
      if (input) input.value = String(quantity);
      card.classList.toggle('is-active', quantity > 0);
      var minus = card.querySelector('[data-hfs-step="-1"]');
      var plus = card.querySelector('[data-hfs-step="1"]');
      if (minus) minus.disabled = quantity <= 0;
      if (plus) plus.disabled = card.classList.contains('is-soldout');
    });
  }

  function initializeEntryFlavor() {
    if (state.entryInitialized || !state.root) return;
    state.entryInitialized = true;
    var variantId = String(state.root.getAttribute('data-entry-variant') || '');
    if (!variantId) return;
    var entryCard = getCards().find(function (card) {
      var ids = String(card.getAttribute('data-flavor-variants') || card.getAttribute('data-id') || '').split(',');
      return ids.indexOf(variantId) !== -1;
    });
    if (!entryCard) return;
    state.entryFlavor = getFlavor(entryCard);
  }

  function rememberFlavorPreference() {
    var counts = snapshotCounters();
    if (Object.keys(counts).some(function (id) { return counts[id] > 0; })) {
      // Keep the shopper's ratio separate from rounded counts in smaller packs.
      state.preferredCounts = counts;
    }
  }

  function getAutomaticCounts(required) {
    if (!Number.isSafeInteger(required) || required < 1) return {};
    var preferred = state.preferredCounts;
    var entries = getCards().map(function (card, index) {
      var id = String(card.getAttribute('data-id') || '');
      return {
        id: id,
        index: index,
        favored: getFlavor(card) === (state.entryFlavor || 'Mint'),
        maximum: card.classList.contains('is-soldout') ? 0 : getCardMaximum(card),
        weight: preferred ? Math.max(0, Number(preferred[id]) || 0) : 1,
        count: 0,
        remainder: 0
      };
    });
    var remaining = required;
    var eligible = entries.filter(function (item) { return item.maximum > 0 && item.weight > 0; });
    while (remaining > 0 && eligible.length) {
      var totalWeight = eligible.reduce(function (sum, item) { return sum + item.weight; }, 0);
      var capped = eligible.filter(function (item) {
        return remaining * (item.weight / totalWeight) >= item.maximum - item.count;
      });
      if (capped.length) {
        capped.forEach(function (item) {
          var amount = Math.min(remaining, item.maximum - item.count);
          item.count += amount;
          remaining -= amount;
        });
        eligible = eligible.filter(function (item) { return item.count < item.maximum; });
        continue;
      }
      var allocation = remaining;
      eligible.forEach(function (item) {
        var share = allocation * (item.weight / totalWeight);
        var amount = Math.floor(share);
        item.count += amount;
        item.remainder = share - amount;
        remaining -= amount;
      });
      eligible.slice().sort(function (a, b) {
        return b.remainder - a.remainder || Number(b.favored) - Number(a.favored) || a.index - b.index;
      }).forEach(function (item) {
        if (remaining > 0 && item.count < item.maximum) {
          item.count += 1;
          remaining -= 1;
        }
      });
      break;
    }
    // A custom all-one-flavor preference never silently substitutes another flavor.
    // Insufficient preferred stock leaves the pack incomplete and Add disabled.
    return entries.reduce(function (counts, item) { counts[item.id] = item.count; return counts; }, {});
  }

  function getPresetCounts(preset) {
    if (!hasValidRequiredQuantity()) return null;
    var cards = getCards();
    var available = cards.filter(function (card) { return !card.classList.contains('is-soldout'); });
    var counts = {};
    if (preset === 'mixed') {
      if (state.requiredQuantity < 2 || available.length < 2) return null;
      available.forEach(function (card, index) {
        var extraFlavor = state.entryFlavor || getFlavor(available[0]);
        var amount = Math.floor(state.requiredQuantity / available.length);
        if (getFlavor(card) === extraFlavor) amount += state.requiredQuantity % available.length;
        counts[String(card.getAttribute('data-id'))] = amount;
      });
    } else {
      var chosen = available.find(function (card) { return getFlavor(card) === preset; });
      if (!chosen) return null;
      counts[String(chosen.getAttribute('data-id'))] = state.requiredQuantity;
    }
    var fitted = fitCounts(counts, state.requiredQuantity);
    var total = Object.keys(fitted).reduce(function (sum, id) { return sum + fitted[id]; }, 0);
    return total === state.requiredQuantity ? fitted : null;
  }

  function applyPreset(preset) {
    var counts = getPresetCounts(preset);
    if (!counts) return;
    clearPendingUpgrade();
    state.extraTins = 0;
    state.selectionNotice = '';
    restoreCounters(counts, state.requiredQuantity);
    syncNativeSelections();
  }

  function remainingCopy(total) {
    var remaining = Math.max(0, state.requiredQuantity - total);
    if (!remaining) return getSelectedMix();
    if (state.extraTins) return 'Choose your ' + remaining + ' extra ' + (remaining === 1 ? 'tin' : 'tins');
    return 'Choose ' + remaining + (total ? ' more ' : ' ') + (remaining === 1 ? 'tin' : 'tins');
  }

  function renderChoiceGuide(total) {
    var guide = state.root.querySelector('[data-hfs-choice-guide]');
    if (!guide) return;
    guide.hidden = false;
    setText(guide.querySelector('[data-hfs-remaining]'), remainingCopy(total));
    var notice = guide.querySelector('[data-hfs-selection-notice]');
    setText(notice, state.selectionNotice);
    if (notice) notice.hidden = !state.selectionNotice;
    guide.querySelectorAll('[data-hfs-preset]').forEach(function (button) {
      var preset = button.getAttribute('data-hfs-preset');
      var counts = getPresetCounts(preset);
      button.hidden = preset === 'mixed' && state.requiredQuantity < 2;
      button.disabled = !counts;
      var selected = Boolean(counts) && getCards().every(function (card) {
        return getQuantity(card) === (counts[String(card.getAttribute('data-id'))] || 0);
      });
      button.setAttribute('aria-pressed', String(selected));
      if (preset === 'mixed') {
        var split = counts ? getCards().filter(function (card) {
          return counts[String(card.getAttribute('data-id'))] > 0;
        }).map(function (card) {
          return counts[String(card.getAttribute('data-id'))] + ' ' + getFlavor(card);
        }).join(' + ') : '';
        setText(button.querySelector('[data-hfs-mix-split]'), split);
      }
    });
  }

  function clearPendingUpgrade() {
    window.clearTimeout(state.pendingUpgradeTimer);
    state.pendingUpgradeTimer = null;
    state.pendingUpgrade = null;
  }

  function setText(element, text) {
    if (element && element.textContent !== text) element.textContent = text;
  }

  function ensureProgress() {
    if (!state.root) return null;

    var legacyStatus = state.root.querySelector('.hfs-bundle-merge__status');
    if (legacyStatus) legacyStatus.remove();

    var progress = state.root.querySelector('[data-hfs-progress]');
    if (!progress) {
      progress = document.createElement('div');
      progress.className = 'hfs-bundle-progress';
      progress.setAttribute('data-hfs-progress', '');
      progress.innerHTML =
        '<div class="hfs-bundle-progress__row">' +
          '<p class="hfs-bundle-progress__message" data-hfs-progress-message role="status" aria-live="polite" aria-atomic="true"></p>' +
          '<span class="hfs-bundle-progress__count" data-hfs-progress-count aria-hidden="true"></span>' +
        '</div>' +
        '<p class="hfs-bundle-progress__summary" data-hfs-pack-summary hidden></p>' +
        '<div class="hfs-bundle-progress__track" data-hfs-progress-track role="progressbar" aria-label="Pack progress" aria-valuemin="0">' +
          '<span class="hfs-bundle-progress__fill" data-hfs-progress-fill></span>' +
        '</div>' +
        '<p class="hfs-bundle-progress__next" data-hfs-progress-next></p>' +
        '<button type="button" class="hfs-bundle-progress__retry" data-hfs-retry hidden>Try again</button>';
      state.root.appendChild(progress);
    }
    return progress;
  }

  function isRefillsSelected() {
    if (!state.bundleRoot) return false;

    var control = state.bundleRoot.querySelector('[role="checkbox"][aria-checked]');
    if (control) return control.getAttribute('aria-checked') === 'true';

    var input = state.bundleRoot.querySelector('input[type="checkbox"]');
    return Boolean(input && input.checked);
  }

  function getDisplayedDealTotal(quantity) {
    var bar = getDealBarByQuantity(quantity);
    var price = bar && bar.querySelector('.kaching-bundles__bar-price');
    var match = price ? String(price.textContent || '').match(/[0-9]+(?:\.[0-9]{1,2})?/) : null;
    var parsed = match ? parseFloat(match[0]) : NaN;

    if (Number.isFinite(parsed) && parsed > 0) return parsed;

    var dealId = getDealId(bar);
    return state.dealPrices[dealId] || BASE_TIN_PRICE * quantity;
  }

  function renderProgress(total, complete) {
    var progress = ensureProgress();
    if (!progress) return;

    var message = progress.querySelector('[data-hfs-progress-message]');
    var count = progress.querySelector('[data-hfs-progress-count]');
    var track = progress.querySelector('[data-hfs-progress-track]');
    var fill = progress.querySelector('[data-hfs-progress-fill]');
    var next = progress.querySelector('[data-hfs-progress-next]');
    var summary = progress.querySelector('[data-hfs-pack-summary]');
    var ready = hasValidRequiredQuantity() && complete && state.nativeSelectionReady && !state.syncing && !state.syncError;
    var remaining = Math.max(0, state.requiredQuantity - total);
    var readyCopy = state.requiredQuantity + '-tin pack ready';
    var mainCopy = '';
    var nextCopy = '';

    if (state.syncError) {
      mainCopy = 'We could not prepare your pack.';
      nextCopy = 'Your choices are saved. Please try again.';
    } else if (complete && !ready) {
      mainCopy = 'Preparing your pack…';
      nextCopy = 'Add to Cart will unlock in a moment.';
    } else if (!complete) {
      mainCopy = remainingCopy(total);
      if (total === 0) nextCopy = state.requiredQuantity === 1 ? 'Mint or Vanilla.' : 'Mint, Vanilla or both.';
    } else {
      mainCopy = readyCopy;
    }

    setText(message, mainCopy);
    setText(count, total + '/' + state.requiredQuantity);
    setText(next, nextCopy);
    if (count) count.hidden = ready;
    if (next) next.hidden = !nextCopy;
    if (summary) {
      setText(summary, total > 0 ? getSelectedMix() : '');
      summary.hidden = total === 0;
    }

    var percent = state.requiredQuantity ? Math.min(100, total / state.requiredQuantity * 100) : 0;
    if (fill && fill.style.width !== percent + '%') fill.style.width = percent + '%';
    if (track) {
      track.hidden = ready;
      track.setAttribute('aria-label', 'Pack progress');
      track.setAttribute('aria-valuemax', String(state.requiredQuantity));
      track.setAttribute('aria-valuenow', String(total));
      track.setAttribute('aria-valuetext', total + ' of ' + state.requiredQuantity + ' tins selected');
    }

    var retry = progress.querySelector('[data-hfs-retry]');
    if (retry) retry.hidden = !state.syncError;
    progress.classList.toggle('is-complete', ready);
    progress.classList.toggle('is-incomplete', !complete && !state.syncError);
    progress.classList.toggle('is-error', state.syncError);
  }

  function getMainButtons() {
    var scope = state.bundleRoot && state.bundleRoot.closest('.product__info-container');
    scope = scope || document;

    return Array.prototype.slice.call(scope.querySelectorAll('product-form .product-form__submit'));
  }

  function setMainButtonReady(ready) {
    ready = ready && hasValidRequiredQuantity();
    if (state.failedOpen) ready = hasValidRequiredQuantity();

    getMainButtons().forEach(function (button) {
      if (button.classList.contains('loading')) return;
      var label = button.querySelector('.main-atc__label__text') || button.querySelector('.main-atc__label');
      if (state.failedOpen) {
        var originalLabel = button.getAttribute('data-hfs-original-label');
        if (originalLabel) setText(label, originalLabel);
        button.removeAttribute('data-hfs-bundle-label');
      } else if (button.getAttribute('data-unavailable') !== 'true') {
        if (!button.hasAttribute('data-hfs-original-label') && label) {
          button.setAttribute('data-hfs-original-label', label.textContent);
        }
        var remaining = Math.max(0, state.requiredQuantity - getTotal());
        var total = getRenderedCaptionTotal(state.requiredQuantity);
        var copy = remaining ? 'Choose ' + remaining + (getTotal() ? ' more ' : ' ') +
          (remaining === 1 ? 'tin' : 'tins') + ' to continue' :
          state.syncError ? 'Your pack needs a retry' : !ready ? 'Preparing your pack…' :
          'Add ' + state.requiredQuantity + (state.requiredQuantity === 1 ? ' tin' : ' tins') +
          (total !== null ? ' · ' + formatMoney(total) : '');
        button.setAttribute('data-hfs-bundle-label', '');
        setText(label, copy);
      }
      if (!ready) {
        if (button.getAttribute('data-hfs-bundle-disabled') !== 'true') {
          button.setAttribute('data-hfs-bundle-disabled', 'true');
        }
        if (!button.disabled) button.disabled = true;
        if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
        return;
      }

      if (button.getAttribute('data-hfs-bundle-disabled') === 'true') {
        button.removeAttribute('data-hfs-bundle-disabled');
      }

      if (button.getAttribute('data-unavailable') !== 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }
    });
  }

  function observeMainButtons() {
    if (state.failedOpen) return;

    var scope = state.bundleRoot && state.bundleRoot.closest('.product__info-container');
    if (!scope || scope === state.observedButtonScope && state.mainButtonObserver) return;

    if (state.mainButtonObserver) state.mainButtonObserver.disconnect();
    state.observedButtonScope = scope;
    state.mainButtonObserver = new MutationObserver(function (records) {
      // Only a submit button's loading class is relevant. Other presentation
      // classes change while rendering the guide and must not trigger a loop.
      var relevant = records.some(function (record) {
        return record.type !== 'attributes' || record.attributeName !== 'class' ||
          record.target.matches('product-form .product-form__submit');
      });
      if (!relevant) return;
      var ready = hasValidRequiredQuantity() && getTotal() === state.requiredQuantity &&
        state.nativeSelectionReady && !state.syncing && !state.syncError;
      // Kaching may re-apply aria-disabled after its variant controls finish
      // updating. Reconcile both states so a fully synced flavor mix stays
      // purchasable instead of being visually complete but keyboard-locked.
      setMainButtonReady(ready);
    });
    state.mainButtonObserver.observe(scope, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true
    });
  }

  // Presentation only: use the app's current offer totals without changing its settings.
  function getRenderedCaptionTotal(quantity) {
    var bar = getDealBarByQuantity(quantity);
    var price = bar && bar.querySelector('.kaching-bundles__bar-price');
    var match = price && String(price.textContent || '').replace(/,/g, '').match(/[0-9]+(?:\.[0-9]{1,2})?/);
    var total = match ? parseFloat(match[0]) : NaN;
    return Number.isFinite(total) && total > 0 ? total : null;
  }

  function syncRenderedDealSubtitles() {
    if (!state.bundleRoot) return;
    state.bundleRoot.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
      var quantity = getDealQuantity(bar);
      var quantityInput = bar && bar.querySelector('.kaching-bundles__quantity-selector__input');
      if (quantityInput && quantityInput.getAttribute('aria-label') !== 'Total tins') quantityInput.setAttribute('aria-label', 'Total tins');
      var subtitle = bar && bar.querySelector('.kaching-bundles__bar-subtitle');
      var total = quantity > 0 ? getRenderedCaptionTotal(quantity) : null;
      if (!subtitle) return;
      var caption = total === null ? '' : formatMoney(total / quantity) + (quantity > 1 ? ' avg. per tin' : ' per tin') +
        (quantity >= 10 && total >= 70 ? ' · Free standard U.S. shipping' : '');
      if (subtitle.textContent === caption) return;
      // Preserve the app's comment anchors and existing text-node ownership.
      var textNode = Array.prototype.find.call(subtitle.childNodes, function (node) { return node.nodeType === 3; });
      if (textNode) textNode.nodeValue = caption;
    });
  }

  function updateSelectionState() {
    if (!state.root) return;

    var total = getTotal();
    var complete = hasValidRequiredQuantity() && total === state.requiredQuantity;

    if (state.requiredQuantity) {
      state.root.querySelectorAll('.hfs-price').forEach(function (price) {
        setText(price, '15 pouches');
      });
    }

    getCards().forEach(function (card) {
      var quantity = getQuantity(card);
      var minus = card.querySelector('[data-hfs-step="-1"]');
      var plus = card.querySelector('[data-hfs-step="1"]');

      if (minus) minus.disabled = quantity <= 0;
      if (plus) {
        plus.disabled = card.classList.contains('is-soldout') || total >= state.requiredQuantity || quantity >= getCardMaximum(card);
      }
    });

    if (complete) state.extraTins = 0;
    renderChoiceGuide(total);
    var refillSubtitle = state.bundleRoot && state.bundleRoot.querySelector('.kaching-bundles__subscriptions__subtitle');
    if (refillSubtitle) {
      var refillText = Array.prototype.find.call(refillSubtitle.childNodes, function (node) { return node.nodeType === 3; });
      var refillCopy = 'Zero commitment, cancel anytime.';
      if (refillText && refillText.nodeValue !== refillCopy) refillText.nodeValue = refillCopy;
    }
    syncRenderedDealSubtitles();
    renderProgress(total, complete);
    setMainButtonReady(complete && state.nativeSelectionReady && !state.syncing && !state.syncError);
    publishPurchaseSelection(complete);
  }

  // Read-only presentation contract. Consumers never set prices or change cart state.
  function publishPurchaseSelection(complete) {
    if (!state.root) return;
    var ready = hasValidRequiredQuantity() && complete && state.nativeSelectionReady && !state.syncing && !state.syncError && !state.failedOpen;
    var total = ready ? getRenderedCaptionTotal(state.requiredQuantity) : null;
    var detail = {
      items: getCards().map(function (card) {
        return { id: String(card.getAttribute('data-id') || ''), quantity: getQuantity(card) };
      }),
      pending: !ready,
      requiredQuantity: state.requiredQuantity,
      subtotalCents: total === null ? null : Math.round(total * 100),
      mode: isRefillsSelected() ? 'refill' : 'one-time',
      revision: ++state.presentationRevision
    };
    state.root.setAttribute('data-hfs-selection', JSON.stringify(detail));
    state.root.dispatchEvent(new CustomEvent('hush:selection-change', { bubbles: true, detail: detail }));
  }

  function desiredFlavors() {
    var flavors = [];

    getCards().forEach(function (card) {
      var name = card.querySelector('.hfs-name');
      var flavor = name ? name.textContent.trim() : '';
      var quantity = getQuantity(card);

      for (var i = 0; i < quantity; i += 1) flavors.push(flavor);
    });

    var available = getCards().filter(function (card) { return !card.classList.contains('is-soldout'); });
    var preferred = available.find(function (card) { return getFlavor(card) === state.entryFlavor; }) || available[0];
    var filler = preferred ? getFlavor(preferred) : 'Mint';
    while (flavors.length < state.requiredQuantity) flavors.push(filler);
    return flavors.slice(0, state.requiredQuantity);
  }

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  async function chooseNativeOption(wrapperIndex, optionName, value, token) {
    if (token !== state.syncVersion) return false;

    var selectedBar = getSelectedBar();
    var wrappers = selectedBar ? selectedBar.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper') : [];
    var wrapper = wrappers[wrapperIndex];
    if (!wrapper) return false;

    var groups = wrapper.querySelectorAll('.kaching-bundles-option');
    var group = Array.prototype.find.call(groups, function (candidate) {
      return String(candidate.getAttribute('aria-label') || '').toLowerCase() === optionName.toLowerCase();
    });
    if (!group) return false;

    if (String(group.getAttribute('data-value') || '').toLowerCase() === String(value).toLowerCase()) {
      return true;
    }

    var option = Array.prototype.find.call(
      group.querySelectorAll('.kaching-bundles-option-value'),
      function (candidate) {
        return String(candidate.getAttribute('data-value') || '').toLowerCase() === String(value).toLowerCase();
      }
    );
    if (!option) return false;

    if (String(group.tagName).toLowerCase() === 'select') {
      try {
        var valueSetter = Object.getOwnPropertyDescriptor(
          window.HTMLSelectElement.prototype,
          'value'
        ).set;
        valueSetter.call(group, option.value);
      } catch (error) {
        group.value = option.value;
      }
      group.dispatchEvent(new Event('input', { bubbles: true }));
      group.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      option.click();
    }

    await wait(70);
    return token === state.syncVersion;
  }

  function hasNativeOption(wrapperIndex, optionName) {
    var selectedBar = getSelectedBar();
    var wrappers = selectedBar ? selectedBar.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper') : [];
    var wrapper = wrappers[wrapperIndex];
    if (!wrapper) return false;

    return Array.prototype.some.call(
      wrapper.querySelectorAll('.kaching-bundles-option'),
      function (candidate) {
        return String(candidate.getAttribute('aria-label') || '').toLowerCase() === optionName.toLowerCase();
      }
    );
  }

  function nativeSelectionsMatch(flavors) {
    if (!hasValidRequiredQuantity()) return false;
    var selectedBar = getSelectedBar();
    var wrappers = selectedBar ? selectedBar.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper') : [];
    if (wrappers.length !== state.requiredQuantity) return false;

    for (var i = 0; i < state.requiredQuantity; i += 1) {
      var groups = wrappers[i].querySelectorAll('.kaching-bundles-option');
      var pack = Array.prototype.find.call(groups, function (group) {
        return String(group.getAttribute('aria-label') || '').toLowerCase() === 'pack size';
      });
      var flavor = Array.prototype.find.call(groups, function (group) {
        return String(group.getAttribute('aria-label') || '').toLowerCase() === 'flavor';
      });

      if (!flavor) return false;
      if (pack && String(pack.getAttribute('data-value') || '').toLowerCase() !== '1 tin') return false;
      if (String(flavor.getAttribute('data-value') || '').toLowerCase() !== String(flavors[i]).toLowerCase()) return false;
    }

    return true;
  }

  function finishNativeSync(token, ready) {
    if (token !== state.syncVersion) return;

    ready = ready && hasValidRequiredQuantity();

    state.syncing = false;
    state.nativeSelectionReady = ready;
    state.syncError = !ready;
    updateSelectionState();
  }

  async function runNativeSync(token, flavors, attempt) {
    if (token !== state.syncVersion) return;
    if (!hasValidRequiredQuantity()) {
      finishNativeSync(token, false);
      return;
    }

    var selectedBar = getSelectedBar();
    var wrappers = selectedBar ? selectedBar.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper') : [];

    if (wrappers.length !== state.requiredQuantity) {
      if (attempt >= 25) {
        finishNativeSync(token, false);
        return;
      }

      await wait(80);
      await runNativeSync(token, flavors, attempt + 1);
      return;
    }

    for (var i = 0; i < state.requiredQuantity; i += 1) {
      if (hasNativeOption(i, 'Pack Size') && !await chooseNativeOption(i, 'Pack Size', '1 Tin', token)) {
        if (token === state.syncVersion) finishNativeSync(token, false);
        return;
      }
      if (!await chooseNativeOption(i, 'Flavor', flavors[i], token)) {
        if (token === state.syncVersion) finishNativeSync(token, false);
        return;
      }
    }

    await wait(80);
    if (token !== state.syncVersion) return;

    if (nativeSelectionsMatch(flavors)) {
      finishNativeSync(token, true);
    } else if (attempt < 5) {
      await runNativeSync(token, flavors, attempt + 1);
    } else {
      finishNativeSync(token, false);
    }
  }

  function syncNativeSelections() {
    var token = ++state.syncVersion;
    var flavors = desiredFlavors();
    state.syncing = true;
    state.nativeSelectionReady = false;
    state.syncError = false;
    updateSelectionState();
    runNativeSync(token, flavors, 0).catch(function () {
      finishNativeSync(token, false);
    });
  }

  function restoreOriginalPosition() {
    if (!state.root || !state.originalParent) return;

    if (state.originalNextSibling && state.originalNextSibling.parentNode === state.originalParent) {
      state.originalParent.insertBefore(state.root, state.originalNextSibling);
    } else {
      state.originalParent.appendChild(state.root);
    }
  }

  function beginPendingUpgrade(targetDealId) {
    var targetBar = state.bundleRoot && Array.prototype.find.call(
      state.bundleRoot.querySelectorAll('.kaching-bundles__bar'),
      function (bar) { return getDealId(bar) === targetDealId; }
    );
    var targetQuantity = getDealQuantity(targetBar);
    if (targetQuantity <= state.requiredQuantity || getTotal() !== state.requiredQuantity) return;
    if (state.syncing || !state.nativeSelectionReady || state.syncError || state.pendingUpgrade) return;

    clearPendingUpgrade();
    var pending = {
      dealId: targetDealId,
      counts: snapshotCounters(),
      expiresAt: Date.now() + 5000
    };
    state.pendingUpgrade = pending;
    state.pendingUpgradeTimer = window.setTimeout(function () {
      if (state.pendingUpgrade !== pending) return;
      clearPendingUpgrade();
      updateSelectionState();
    }, 5000);
    updateSelectionState();
    return pending;
  }

  function upgradeToQuantity(targetQuantity) {
    if (targetQuantity <= state.requiredQuantity || getTotal() !== state.requiredQuantity) return;
    if (state.syncing || !state.nativeSelectionReady || state.syncError || state.pendingUpgrade) return;

    var targetBar = getDealBarByQuantity(targetQuantity);
    var targetDealId = getDealId(targetBar);
    var targetControl = targetBar && (
      targetBar.querySelector('.kaching-bundles__bar-main') ||
      targetBar.querySelector('input[type="radio"]')
    );
    if (!targetDealId || !targetControl) return;

    var pending = beginPendingUpgrade(targetDealId);
    if (!pending) return;

    window.setTimeout(function () {
      if (state.pendingUpgrade === pending) targetControl.click();
    }, 0);
  }

  function applySelectedDeal(forceSync) {
    state.bundleRoot = document.querySelector('.kaching-bundles');
    if (!state.root || !state.bundleRoot) return;

    var selectedBar = getSelectedBar();
    if (!selectedBar) return;

    var dealId = getDealId(selectedBar);
    var required = getDealQuantity(selectedBar);
    if (!required) {
      state.requiredQuantity = 0;
      state.syncVersion += 1;
      state.syncing = false;
      state.nativeSelectionReady = false;
      state.syncError = true;
      updateSelectionState();
      return;
    }
    var changed = dealId !== state.currentDealId || required !== state.requiredQuantity;
    var focusAfterUpgrade = false;

    if (changed) {
      if (state.pendingUpgrade) {
        if (state.pendingUpgrade.dealId === dealId && state.pendingUpgrade.expiresAt >= Date.now()) {
          focusAfterUpgrade = true;
        }
        clearPendingUpgrade();
      }

      state.extraTins = 0;
      state.selectionNotice = '';
      state.currentDealId = dealId;
      state.requiredQuantity = required;
      state.syncVersion += 1;
      state.syncing = false;
      state.nativeSelectionReady = false;
      state.syncError = false;
      initializeEntryFlavor();
      resetCounters();
      restoreCounters(getAutomaticCounts(required), required);
    } else {
      state.requiredQuantity = required;
    }

    var wrapper = selectedBar.querySelector('.kaching-bundles__bar-wrapper') || selectedBar;
    var main = wrapper.querySelector('.kaching-bundles__bar-main');
    if (main && main.nextElementSibling !== state.root) main.insertAdjacentElement('afterend', state.root);
    else if (!main && state.root.parentNode !== wrapper) wrapper.appendChild(state.root);

    state.root.classList.add('hfs-bundle-merge--visible');
    updateSelectionState();

    if (focusAfterUpgrade) {
      window.setTimeout(function () {
        var nextFlavor = state.root && state.root.querySelector('#hush-pack-builder');
        if (!nextFlavor) return;
        try {
          nextFlavor.focus({ preventScroll: true });
          nextFlavor.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
        } catch (error) {
          nextFlavor.focus();
        }
      }, 0);
    }

    var flavors = desiredFlavors();
    if (!state.syncing && nativeSelectionsMatch(flavors)) {
      state.nativeSelectionReady = true;
      state.syncError = false;
      updateSelectionState();
    } else if (!state.syncing && (changed || forceSync || !nativeSelectionsMatch(flavors))) {
      syncNativeSelections();
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(state.refreshTimer);
    state.refreshTimer = window.setTimeout(function () {
      applySelectedDeal(false);
      observeBundle();
    }, 60);
  }

  function observeBundle() {
    var currentBundle = document.querySelector('.kaching-bundles');
    if (!currentBundle || currentBundle === state.observedBundle && state.observer) return;

    if (state.observer) state.observer.disconnect();
    state.bundleRoot = currentBundle;
    state.observedBundle = currentBundle;
    state.observer = new MutationObserver(function (records) {
      var relevant = records.some(function (record) {
        return !(state.root && (record.target === state.root || state.root.contains(record.target)));
      });
      if (relevant) scheduleRefresh();
    });
    state.observer.observe(currentBundle, {
      attributes: true,
      attributeFilter: ['class', 'data-value', 'aria-checked', 'checked', 'value'],
      characterData: true,
      childList: true,
      subtree: true
    });
  }

  function setup() {
    var liveRoot = document.querySelector('[data-hfs]');
    var root = state.root && state.root.isConnected ? state.root : (liveRoot || state.root);
    var bundle = document.querySelector('.kaching-bundles');
    if (!root || !bundle) return false;

    var rootChanged = root !== state.root;
    state.root = root;
    state.bundleRoot = bundle;

    if (rootChanged || !state.originalParent) {
      state.originalParent = root.parentNode;
      state.originalNextSibling = root.nextSibling;
    }

    root.querySelectorAll('[data-hfs-qty]').forEach(function (input) {
      input.readOnly = true;
      input.setAttribute('aria-readonly', 'true');
    });

    if (!root.getAttribute('data-hfs-bundle-listeners')) {
      root.setAttribute('data-hfs-bundle-listeners', 'true');

      root.addEventListener('click', function (event) {
        var preset = event.target.closest('[data-hfs-preset]');
        if (preset && root.contains(preset)) {
          event.preventDefault();
          event.stopPropagation();
          applyPreset(preset.getAttribute('data-hfs-preset'));
          return;
        }
        var retry = event.target.closest('[data-hfs-retry]');
        if (retry && root.contains(retry)) {
          event.preventDefault();
          event.stopPropagation();
          syncNativeSelections();
          return;
        }
        var upgrade = event.target.closest('[data-hfs-upgrade]');
        if (upgrade && root.contains(upgrade)) {
          event.preventDefault();
          event.stopPropagation();
          upgradeToQuantity(parseInt(upgrade.getAttribute('data-target-quantity'), 10) || 0);
          return;
        }

        var step = event.target.closest('[data-hfs-step]');
        if (!step || !root.contains(step)) return;

        if (step.getAttribute('data-hfs-step') === '1' && getTotal() >= state.requiredQuantity) {
          event.preventDefault();
          event.stopPropagation();
          updateSelectionState();
          return;
        }

        state.selectionNotice = '';
        window.setTimeout(function () {
          rememberFlavorPreference();
          updateSelectionState();
          syncNativeSelections();
        }, 0);
      }, true);
    }

    var packHeading = document.querySelector('[data-hfs-pack-heading]');
    if (!packHeading) {
      packHeading = document.createElement('h2');
      packHeading.className = 'hfs-pack-heading';
      packHeading.setAttribute('data-hfs-pack-heading', '');
      packHeading.textContent = '1. Choose your pack';
      bundle.insertAdjacentElement('beforebegin', packHeading);
    }
    observeBundle();
    observeMainButtons();
    document.documentElement.classList.remove('hfs-bundle-merge-loading');
    document.documentElement.classList.add('hfs-bundle-merge-ready');
    applySelectedDeal(true);
    return true;
  }

  function failOpen() {
    state.failedOpen = true;
    if (state.mainButtonObserver) state.mainButtonObserver.disconnect();
    state.mainButtonObserver = null;
    state.observedButtonScope = null;
    document.documentElement.classList.remove('hfs-bundle-merge-loading');
    document.documentElement.classList.remove('hfs-bundle-merge-ready');
    state.syncing = false;
    state.syncError = true;
    setMainButtonReady(true);
    publishPurchaseSelection(false);
  }

  document.addEventListener('click', function (event) {
    // Let Kaching's quantity buttons and input receive their own clicks, even
    // when the selected bar's main area contains them.
    if (event.target.closest('.kaching-bundles__quantity-selector')) {
      invalidateNativeQuantity();
      return;
    }
    var refillControl = event.target.closest('.kaching-bundles__subscriptions [role="checkbox"]');
    if (refillControl) {
      publishPurchaseSelection(false);
      window.setTimeout(function () {
        updateSelectionState();
      }, 100);
    }

    var barMain = event.target.closest('.kaching-bundles__bar-main');
    if (barMain) {
      var clickedBar = barMain.closest('.kaching-bundles__bar');
      var clickedRadio = clickedBar && clickedBar.querySelector('input[type="radio"]');

      if (clickedBar && (
        clickedBar.classList.contains('kaching-bundles__bar--selected') ||
        clickedRadio && clickedRadio.checked
      )) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      var clickedDealId = getDealId(clickedBar);
      var clickedQuantity = getDealQuantity(clickedBar);
      if (clickedQuantity > state.requiredQuantity && !state.pendingUpgrade) {
        beginPendingUpgrade(clickedDealId);
      }

      state.syncVersion += 1;
      state.syncing = false;
      state.nativeSelectionReady = false;
      state.syncError = false;
      setMainButtonReady(false);
      publishPurchaseSelection(false);
      window.setTimeout(function () {
        applySelectedDeal(true);
      }, 50);
    }

    var submit = event.target.closest('product-form .product-form__submit');
    var ready = hasValidRequiredQuantity() && getTotal() === state.requiredQuantity &&
      state.nativeSelectionReady && !state.syncing && !state.syncError;
    if (submit && (!hasValidRequiredQuantity() || !ready && !state.failedOpen)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setMainButtonReady(false);
    }
  }, true);

  function invalidateNativeQuantity() {
    state.syncVersion += 1;
    state.syncing = false;
    state.nativeSelectionReady = false;
    state.syncError = false;
    setMainButtonReady(false);
    publishPurchaseSelection(false);
    scheduleRefresh();
  }

  function handleNativeQuantityChange(event) {
    if (event.target.matches('.kaching-bundles__quantity-selector__input')) invalidateNativeQuantity();
  }

  document.addEventListener('input', handleNativeQuantityChange, true);
  document.addEventListener('change', handleNativeQuantityChange, true);

  document.addEventListener('submit', function (event) {
    var ready = hasValidRequiredQuantity() && getTotal() === state.requiredQuantity &&
      state.nativeSelectionReady && !state.syncing && !state.syncError;
    if (!hasValidRequiredQuantity() || !ready && !state.failedOpen) {
      var form = event.target;
      if (form && form.closest && form.closest('product-form')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setMainButtonReady(false);
      }
    }
  }, true);

  window.addEventListener('kaching-bundles-initialized', function () {
    setup();
  });

  // Checkout's optional offer uses the same native pack controls and stock rules.
  window.HushPackSelection = {
    getUpgradeOffer: function () {
      if (!state.root || state.failedOpen || state.syncing || state.syncError || !state.nativeSelectionReady || getTotal() !== state.requiredQuantity) return null;
      var next = PACK_QUANTITIES[PACK_QUANTITIES.indexOf(state.requiredQuantity) + 1];
      if (!next || next <= state.requiredQuantity) return null;
      var bar = state.bundleRoot && Array.prototype.find.call(state.bundleRoot.querySelectorAll('.kaching-bundles__bar'), function (bar) {
        return state.dealQuantities[getDealId(bar)] === next;
      });
      var quantity = getDealQuantity(bar);
      var counts = getAutomaticCounts(quantity);
      if (Object.keys(counts).reduce(function (sum, id) { return sum + counts[id]; }, 0) !== quantity) return null;
      var current = getRenderedCaptionTotal(state.requiredQuantity);
      var total = getRenderedCaptionTotal(quantity);
      if (current === null || total === null || total <= current) return null;
      return {
        quantity: quantity,
        extraQuantity: quantity - state.requiredQuantity,
        subtotalCents: Math.round(total * 100),
        extraCents: Math.round(total * 100) - Math.round(current * 100),
        mode: isRefillsSelected() ? 'refill' : 'one-time',
        items: getCards().map(function (card) {
          var id = String(card.getAttribute('data-id') || '');
          return { id: id, quantity: counts[id] || 0 };
        })
      };
    },
    upgrade: function (quantity) {
      var offer = this.getUpgradeOffer();
      if (!offer || offer.quantity !== quantity) return false;
      upgradeToQuantity(quantity);
      return true;
    }
  };

  function boot() {
    parseAndPatchDealSettings();
    startKaching();

    var attempts = 0;
    var setupTimer = window.setInterval(function () {
      attempts += 1;
      if (setup()) {
        window.clearInterval(setupTimer);
      } else if (attempts >= 300) {
        window.clearInterval(setupTimer);
        failOpen();
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
